/**
 * . 属性访问器 转换为 []，如 [7]a[0][7][8].b.c 转换为 [7][a][0][7][8][b][c]
 */
export function dotNotationToBracketNotation(str: string): string {
  // const p = '[7]a[0][7][8].b.c'
  // const p2 = '[7][a][0][7][8][b][c]'
  // const p3 = config
  // const p4 = [config]
  const regex = /(\[)|(])/g
  return str
    .replace(regex, '.')
    .split('.')
    .filter((item) => !!item)
    .map((item) => `[${item}]`)
    .join('')
}

export function isUrl(str: string): boolean {
  let url: URL

  try {
    url = new URL(str)
  } catch (_) {
    return false
  }

  return url.protocol === 'http:' || url.protocol === 'https:'
}
